import type { ExampleIconAliases } from './icons';

const aliases: ExampleIconAliases = {
  dark: 'mdi-weather-night',
  light: 'mdi-weather-sunny',
  lightdark: 'mdi-theme-light-dark',
  ltr: 'mdi-format-pilcrow-arrow-right',
  rtl: 'mdi-format-pilcrow-arrow-left',
  palette: 'mdi-palette',
  settings: 'mdi-cog',
  formatText: 'mdi-format-text',
  iconFormWrapperShow: 'mdi-fullscreen-exit',
  iconFormWrapperHide: 'mdi-fullscreen',
  reload: 'mdi-reload',
  save: 'mdi-content-save',
  github: 'mdi-github',
};

export { aliases };
